import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { IconComponent } from './icon.component';
import { TranslatePipe } from '../pipes/translate.pipe';

interface TagDef { t: string; bg: string; fg: string; icon: string; }
const MAP: Record<string, TagDef> = {
  best: { t: 'Best seller', bg: 'var(--gold-tint)', fg: 'var(--gold-deep)', icon: 'solar:star-bold' },
  new: { t: 'New', bg: 'color-mix(in srgb, var(--fr-info) 14%, #fff)', fg: 'var(--fr-info-strong)', icon: 'solar:bolt-bold' },
  spicy: { t: 'Spicy', bg: 'color-mix(in srgb, var(--brand) 14%, #fff)', fg: 'var(--brand-deep)', icon: 'solar:fire-bold' },
};

/** Small item badge: best-seller / new / spicy. */
@Component({
  selector: 'app-tag',
  standalone: true,
  imports: [NgIf, IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span *ngIf="def" [style.background]="def.bg" [style.color]="def.fg"
      style="display:inline-flex;align-items:center;gap:4px;height:22px;padding:0 8px 0 6px;border-radius:7px;
             font-size:11.5px;font-weight:750;letter-spacing:-0.01em">
      <app-icon [name]="def.icon" [size]="12"></app-icon> {{ def.t | t }}
    </span>`,
})
export class TagComponent {
  @Input() set kind(k: string) { this.def = MAP[k]; }
  def?: TagDef;
}
